import React from "react";
import { Link } from "react-router-dom";
import { Button, Table, Modal } from "react-bootstrap";
import HelpHintButton from "components/HelpHintButton";

class ClientTable extends React.Component {
	state = {
		showFullTable: false
	};

	constructor(props) {
		super(props);

		this.handleToggleFullTable = this.handleToggleFullTable.bind(this);
	}

	handleToggleFullTable() {
		this.setState({showFullTable: !this.state.showFullTable});
	}

	renderTable(clients) {
		const {event} = this.props;

		var fields = {
			surname: 'Фамилия',
			name: 'Имя',
			patronymic: 'Отчество',
			link: 'Профиль'
		};

		event.registrationFields.forEach(fieldToEvent => {
			const field = fieldToEvent.field;
			if(!fields[field.name]) {
				fields[field.name] = field.label_ru;
			}
		});

		const getTypedData = (info, key) => {
			if (!info) return '';

			const field = event.registrationFields.find(({field}) => field.name === key);
			if (!field) return '';

			if (['checkbox', 'disclaimer'].includes(field.field.type)) {
				return info[key] === true ? 'Да' : 'Нет';
				// return info[key] === true ? 'Да' : info[key] === false ? 'Нет' : '';
			}

			return info[key] || '';
		}

		const getClientInfo = (client, key) => {
			const socialTypes = {
				guest: 'Гость',
				email: 'COMDI',
				vk: 'Вконтакте',
				facebook: "Facebook",
				twitter: "Twitter",
				mailru: "Mail.ru",
				linkedin: "Linked.in",
				google: "Google",
				ok: "Одноклассники",
				yandex: "Яндекс",
				kaspersky: "Касперский",
			};

            if (client.info?.[key] instanceof Object && client.info?.[key].organizationName) {
                let org = client.info[key];
                return `${org.organizationName} (ИНН: ${org.organizationInn}, КПП: ${org.organizationKpp})`;
            }

			switch(key) {
				case 'link': return client.info?.link ? <a href={client.info?.link} target="_blank">{socialTypes[client.type] || 'Перейти'}</a> : null;
				default: return client[key] || getTypedData(client.info, key);
			}
		};

		return (
			<Table>
				<thead>
				<tr>
					<th>ID</th>
					<th>eMail</th>
					{Object.keys(fields).map(key => <th key={key}>{fields[key]}</th>)}
				</tr>
				</thead>
				<tbody>
				{clients.map(client =>
					<tr key={client.id}>
						<td><Link to={`/event/${event.eventPassword}/client/${client.id}`}>{client.id}</Link></td>
						<td>{client.email || ''}</td>
						{Object.keys(fields).map(key => <td key={key}>{getClientInfo(client, key)}</td>)}
					</tr>
				)}
				</tbody>
			</Table>
		);
	}

	render() {
		const {clients, event, timeStart, timeStop, hideButtons} = this.props;
		const clientsList = this.props.full ? clients : clients.slice(0, 10);

		return (
			<div>
				{this.renderTable(clientsList)}
                {!hideButtons &&
                <div style={{textAlign: 'right'}}>
                    {event.moduleMain.statisticWatchReport && <Button href={`/api/cp/event/${event.eventPassword}/statistic/watch.xlsx`}>
                        Скачать статистику просмотров
                    </Button>}
                    <Button href={`/api/cp/event/${event.eventPassword}/client/tracking.xlsx`}>
                        Скачать действия на лендинге
                        <HelpHintButton placement="top">
                            <p>Данные о действиях посетителей вашего лендинга, созданного в конструкторе COMDI</p>
                        </HelpHintButton>
					</Button>
                    {' '}
                    {' '}
                    {/*<ButtonGroup>
                        <Button
                            href={`/api/cp/event/${event.eventPassword}/client.xlsx?timeStart=${timeStart}&timeStop=${timeStop}`}>Скачать
                            за выбранный период</Button>
                        <Button href={`/api/cp/event/${event.eventPassword}/client.xlsx`}>Скачать за весь
                            период</Button>
                    </ButtonGroup>
                    {' '}*/}
                    {clients.length > 10 && clients.length !== clientsList.length &&
                    <Button onClick={this.handleToggleFullTable}>Показать все</Button>}
                </div>
                }

				<Modal show={this.state.showFullTable} onHide={this.handleToggleFullTable} bsSize="large">
					<Modal.Header closeButton>
						<Modal.Title>Зрители</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{overflow: 'auto'}}>
						{this.renderTable(clients)}
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.handleToggleFullTable}>Закрыть</Button>
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}

export default ClientTable;
